<template>
  <div id="ma-no-caps">
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Pessoas atendidas"
            description="Monitoramento e Acompanhamento no CAPS"
            url="/caps"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-9151"
            pageIdentifier="ma-no-caps"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-lg-6 col-md-8">
          <vue-select
            id="select-estabelecimento"
            v-model="selectedEstabelecimento"
            :options="optionsEstabelecimentos"
            label="label"
            placeholder="Unidade de Saúde"
            :loading="loadingEstabelecimentos"
            :disabled="loadingEstabelecimentos"
            :clearable="false"
            @input="onChangeEstabelecimento"
          >
            <template slot="option" slot-scope="option">
              {{ option.label }}
            </template>
            <div slot="no-options">Não há opções correspondentes</div>
          </vue-select>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="info-table py-4">
            <!-- <div class="info-table-item">
              <Subtitle
                @exibirVermelhos="handleExibirVermelhos"
                @exibirVerdes="handleExibirVerdes"
                :setRed="setRed"
              ></Subtitle>
            </div>
            <div class="info-table-item">
              <vue-select
                v-model="selectedFilterVulnerabilidade"
                :options="optionsFilterVulnerabilidade"
                label="label"
                placeholder="Vulnerabilidade"
                :clearable="true"
                @input="onChangeFilterVulnerabilidade"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div> -->
            <div class="info-table-item">
              <download-files
                :callback-pdf="generatePdf"
                :data="displayedCadastros"
                :fields="dataFields"
                name="ma_no_caps"
              >
              </download-files>
            </div>
          </div>

          <tabela-cadastros
            ref="table"
            :cadastros="displayedCadastros"
            :loading="loading"
            @filterSearch="filterSearch($event)"
          ></tabela-cadastros>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import Subtitle from './Subtitle.vue'
import TabelaCadastros from './TabelaCadastros.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import * as Functions from './functions.js'
import * as Filter from './filter.js'
import { dataFields, optionsFilterVulnerabilidade } from './utils.js'
import utils from '@/mixins/utils.js'

export default {
  name: 'MaNoCaps',
  components: {
    Menu,
    Footer,
    SectionTitle,
    Subtitle,
    TabelaCadastros,
    DownloadFiles,
  },
  mixins: [utils],
  data() {
    return {
      estabelecimentos: [],
      selectedEstabelecimento: null,
      loadingEstabelecimentos: false,
      loading: false,
      pacientesTodos: [],
      cadastros: [],
      cadastrosOriginais: [],
      filterSearchTable: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      setRed: false,
      optionsFilterVulnerabilidade: [...optionsFilterVulnerabilidade],
      selectedFilterVulnerabilidade: null,
      dataFields: {
        ...dataFields,
      },
    }
  },
  computed: {
    optionsEstabelecimentos() {
      return (this.estabelecimentos || []).map((item) => {
        const nome =
          item.no_unidade_saude || item.no_estabelecimento || item.nome || ''
        const cnes = item.cnes || item.nu_cnes || item.co_cnes || ''
        const label = cnes ? `${nome} - ${cnes}` : nome
        return {
          ...item,
          nu_cnes: cnes,
          no_unidade_saude: nome,
          label: label,
        }
      })
    },
    displayedCadastros() {
      if (this.filterSearchTable !== false) {
        return this.filterSearchTable
      }
      let response = Filter.filtro(
        this.cadastros,
        this.exibirCadastrosVermelhos,
        this.exibirCadastrosVerdes,
        this.selectedFilterVulnerabilidade
      )
      if (response === undefined) {
        response = []
      }
      return response
    },
  },
  methods: {
    /**
     * Habilita os filtros vermelho/verde
     *
     * @param {Boolean} vermelho
     * @param {Boolean} verde
     */
    filtros(vermelho, verde) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (vermelho === true) {
        this.setRed = true
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
        return
      }
      if (verde === true) {
        this.setRed = false
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
        return
      }
      this.setRed = false
    },

    /**
     * Atualiza o filtro para exibir registros classificados como vermelhos (faltosos).
     * @param {Boolean} event
     */
    handleExibirVermelhos(event) {
      if (event === true) {
        this.filtros(true, false)
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVermelhos = false
      }
    },

    /**
     * Atualiza o filtro para exibir registros classificados como verdes (em dia).
     * @param {Boolean} event
     */
    handleExibirVerdes(event) {
      if (event === true) {
        this.filtros(false, true)
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVerdes = false
      }
    },

    /**
     * Carrega os dados do M & A no CAPS
     */
    async carregarDados() {
      try {
        this.loadingEstabelecimentos = true
        const response = await Functions.getMaNoCaps(this.$store.state.cod_ibge)
        const { estabelecimentos, pacientes } =
          Functions.parseMaNoCapsResponse(response)

        this.estabelecimentos = estabelecimentos
        this.pacientesTodos = pacientes
      } catch (error) {
        console.error('Erro ao carregar dados do M & A no CAPS:', error)
        this.estabelecimentos = []
        this.pacientesTodos = []
      } finally {
        this.loadingEstabelecimentos = false
      }
    },

    /**
     * Disparado ao alterar o estabelecimento selecionado
     */
    async onChangeEstabelecimento(item) {
      this.selectedEstabelecimento = item
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (item) {
        await this.buscarPacientesPorEstabelecimento()
      } else {
        this.cadastros = []
        this.cadastrosOriginais = []
      }
    },

    /**
     * Busca os pacientes do estabelecimento selecionado
     */
    async buscarPacientesPorEstabelecimento() {
      if (!this.selectedEstabelecimento) return
      try {
        this.loading = true
        const cnes =
          this.selectedEstabelecimento.cnes ||
          this.selectedEstabelecimento.nu_cnes ||
          this.selectedEstabelecimento.co_cnes
        const data = Functions.getPacientesPorEstabelecimento(
          this.pacientesTodos,
          cnes
        )
        this.cadastros = Array.isArray(data) ? data : []
        this.cadastrosOriginais = this.cadastros
      } catch (error) {
        console.error('Erro ao buscar pacientes CAPS:', error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Manipula a busca por texto na tabela
     */
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    /**
     * Manipula alteração no filtro de vulnerabilidade
     */
    onChangeFilterVulnerabilidade() {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
    },

    /**
     * Gera relatório PDF dos pacientes listados
     */
    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.selectedEstabelecimento
      )
    },
  },
  created() {
    this.carregarDados()
  },
}
</script>

<style src="./styles.scss" scoped lang="scss" />
